module.exports = __webpack_public_path__ + "img/mb-search-empty-bg.d57abe1f.png";